import { updateUserContext } from "@utils/api/tracker";
import { ActionHandlerParams } from "..";
import { shouldShowNoomClinicalCheckoutOffer } from "src/utils/userSegment/features";
import saveToBraze from "@utils/brazeUploader";
import { getRouteId } from "@utils/meristemContext";
import { saveAnswers } from "./saveAnswers";

type Params = {
  finishedEvent?: string;
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompletePaymentSurvey = async (
  actionParams: {
    params?: Params;
  } & ActionHandlerParams
) => {
  const { params = {} } = actionParams;

  const currentAnswers = await saveAnswers({
    ...actionParams,
    params: {
      ...params,
      dateKey: params.dateKey || "purchaseSurveyCompleteDateISO",
    },
  });

  updateUserContext({
    telehealthEligible: shouldShowNoomClinicalCheckoutOffer(),
  });

  await saveToBraze({
    event: {
      event_name: "finished_payment_survey",
      event_data: { routeId: getRouteId(), ...currentAnswers },
    },
  });
};
